import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import type { FC } from "react";
import { Link } from "react-router";

import { GetUpdatesFinePrint } from "~/feature/getUpdates/components/GetUpdatesFinePrint";
import { LIFETIME_PREMIUM_CTA_URL } from "~/feature/getUpdates/constants";

import * as Styled from "./LifetimePremiumContent.styles";

const benefits = [
  {
    lead: "Every filter, unlocked.",
    rest: "Spreads, min APY, min ROI, 24h volume and more.",
  },
  {
    lead: "Watchlists that stay with you.",
    rest: "Saved to your account, not your browser, so they’re there on every device.",
  },
  {
    lead: "New features, included.",
    rest: "Everything we add to the Standard plan is included in yours, at no cost.",
  },
  { lead: "Founding Member badge." },
];

interface ILifetimePremiumContentProps {
  onClose: () => void;
}

export const LifetimePremiumContent: FC<ILifetimePremiumContentProps> = ({
  onClose,
}) => {
  return (
    <Styled.Root>
      <Styled.Chip>
        <WorkspacePremiumOutlinedIcon />
        FIRST 100 MEMBERS ONLY
      </Styled.Chip>
      <Styled.Headline>
        Our paid plan. <Styled.Highlight>FREE</Styled.Highlight> for life.
      </Styled.Headline>
      <Styled.Subhead>
        PredictionHero compares Polymarket, Kalshi and other prediction markets
        side by side. Our paid plan unlocks the filters and tools to go deeper.
      </Styled.Subhead>
      <Styled.PriceRow>
        <Styled.PriceValue>FREE</Styled.PriceValue>
        <Styled.PriceDetails>
          <Styled.PriceWorth>
            Worth <s>$299.40 a year</s>
          </Styled.PriceWorth>
          <Styled.PriceNote>No trial, nothing to cancel.</Styled.PriceNote>
        </Styled.PriceDetails>
      </Styled.PriceRow>
      <Styled.Eyebrow>WHAT YOU GET</Styled.Eyebrow>
      <Styled.Bullets>
        {benefits.map(({ lead, rest }) => (
          <Styled.Bullet key={lead}>
            <Styled.BulletCheck>
              <CheckRoundedIcon />
            </Styled.BulletCheck>
            <Styled.BulletText>
              <strong>{lead}</strong> {rest}
            </Styled.BulletText>
          </Styled.Bullet>
        ))}
      </Styled.Bullets>
      <Styled.ClaimLink
        component={Link}
        to={LIFETIME_PREMIUM_CTA_URL}
        onClick={onClose}
        endIcon={<ArrowForwardRoundedIcon />}
        fullWidth
      >
        Claim my free plan
      </Styled.ClaimLink>
      <Styled.Microcopy>
        Takes under a minute. Activation occurs within 24 hours of signing up.
      </Styled.Microcopy>
      <GetUpdatesFinePrint agreement="signing up" newTab />
    </Styled.Root>
  );
};
